var parseVersion = (str) => {
	// see webpack/lib/util/semver.js for original code
	var p=p=>{return p.split(".").map(p=>{return+p==p?+p:p})},n=/^([^-+]+)?(?:-([^+]+))?(?:\+(.+))?$/.exec(str),r=n[1]?p(n[1]):[];return n[2]&&(r.length++,r.push.apply(r,p(n[2]))),n[3]&&(r.push([]),r.push.apply(r,p(n[3]))),r;
}
var versionLt = (a, b) => {
	// see webpack/lib/util/semver.js for original code
	a=parseVersion(a),b=parseVersion(b);for(var r=0;;){if(r>=a.length)return r<b.length&&"u"!=(typeof b[r])[0];var e=a[r],n=(typeof e)[0];if(r>=b.length)return"u"==n;var t=b[r],f=(typeof t)[0];if(n!=f)return"o"==n&&"n"==f||("s"==f||"u"==n);if("o"!=n&&"u"!=n&&e!=t)return e<t;r++}
}
var rangeToString = (range) => {
	// see webpack/lib/util/semver.js for original code
	var r=range[0],n="";if(1===range.length)return"*";if(r+.5){n+=0==r?">=":-1==r?"<":1==r?"^":2==r?"~":r>0?"=":"!=";for(var e=1,a=1;a<range.length;a++){e--,n+="u"==(typeof(t=range[a]))[0]?"-":(e>0?".":"")+(e=2,t)}return n}var g=[];for(a=1;a<range.length;a++){var t=range[a];g.push(0===t?"not("+o()+")":1===t?"("+o()+" || "+o()+")":2===t?g.pop()+" "+g.pop():rangeToString(t))}return o();function o(){return g.pop().replace(/^\((.+)\)$/,"$1")}
}
var satisfy = (range, version) => {
	// see webpack/lib/util/semver.js for original code
	if(0 in range){version=parseVersion(version);var e=range[0],r=e<0;r&&(e=-e-1);for(var n=0,i=1,a=!0;;i++,n++){var f,s,g=i<range.length?(typeof range[i])[0]:"";if(n>=version.length||"o"==(s=(typeof(f=version[n]))[0]))return!a||("u"==g?i>e&&!r:""==g!=r);if("u"==s){if(!a||"u"!=g)return!1}else if(a)if(g==s)if(i<=e){if(f!=range[i])return!1}else{if(r?f>range[i]:f<range[i])return!1;f!=range[i]&&(a=!1)}else if("s"!=g&&"n"!=g){if(r||i<=e)return!1;a=!1,i--}else{if(i<=e||s<g!=r)return!1;a=!1}else"s"!=g&&"n"!=g&&(a=!1,i--)}}var t=[],o=t.pop.bind(t);for(n=1;n<range.length;n++){var u=range[n];t.push(1==u?o()|o():2==u?o()&o():u?satisfy(u,version):!o())}return!!o();
}
var exists = (scope, key) => {
	return scope && __webpack_require__.o(scope, key);
}
var get = (entry) => {
	entry.loaded = 1;
	return entry.get()
};
var eagerOnly = (versions) => {
	return Object.keys(versions).reduce((filtered, version) => {
			if (versions[version].eager) {
				filtered[version] = versions[version];
			}
			return filtered;
	}, {});
};
var findLatestVersion = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key];
};
var findSatisfyingVersion = (scope, key, requiredVersion, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	var key = Object.keys(versions).reduce((a, b) => {
		if (!satisfy(requiredVersion, b)) return a;
		return !a || versionLt(a, b) ? b : a;
	}, 0);
	return key && versions[key]
};
var findSingletonVersionKey = (scope, key, eager) => {
	var versions = eager ? eagerOnly(scope[key]) : scope[key];
	return Object.keys(versions).reduce((a, b) => {
		return !a || (!versions[a].loaded && versionLt(a, b)) ? b : a;
	}, 0);
};
var getInvalidSingletonVersionMessage = (scope, key, version, requiredVersion) => {
	return "Unsatisfied version " + version + " from " + (version && scope[key][version].from) + " of shared singleton module " + key + " (required " + rangeToString(requiredVersion) + ")"
};
var getInvalidVersionMessage = (scope, scopeName, key, requiredVersion, eager) => {
	var versions = scope[key];
	return "No satisfying version (" + rangeToString(requiredVersion) + ")" + (eager ? " for eager consumption" : "") + " of shared module " + key + " found in shared scope " + scopeName + ".\n" +
		"Available versions: " + Object.keys(versions).map((key) => {
		return key + " from " + versions[key].from;
	}).join(", ");
};
var fail = (msg) => {
	throw new Error(msg);
}
var failAsNotExist = (scopeName, key) => {
	return fail("Shared module " + key + " doesn't exist in shared scope " + scopeName);
}
var warn = /*#__PURE__*/ (msg) => {
	if (typeof console !== "undefined" && console.warn) console.warn(msg);
};
var init = (fn) => (function(scopeName, key, eager, c, d) {
	var promise = __webpack_require__.I(scopeName);
	if (promise && promise.then && !eager) {
		return promise.then(fn.bind(fn, scopeName, __webpack_require__.S[scopeName], key, false, c, d));
	}
	return fn(scopeName, __webpack_require__.S[scopeName], key, eager, c, d);
});

var useFallback = (scopeName, key, fallback) => {
	return fallback ? fallback() : failAsNotExist(scopeName, key);
}
var load = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	return get(findLatestVersion(scope, key, eager));
});
var loadVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	warn(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager))
	return get(findLatestVersion(scope, key, eager));
});
var loadStrictVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var satisfyingVersion = findSatisfyingVersion(scope, key, requiredVersion, eager);
	if (satisfyingVersion) return get(satisfyingVersion);
	if (fallback) return fallback();
	fail(getInvalidVersionMessage(scope, scopeName, key, requiredVersion, eager));
});
var loadSingleton = /*#__PURE__*/ init((scopeName, scope, key, eager, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	return get(scope[key][version]);
});
var loadSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		warn(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var loadStrictSingletonVersion = /*#__PURE__*/ init((scopeName, scope, key, eager, requiredVersion, fallback) => {
	if (!exists(scope, key)) return useFallback(scopeName, key, fallback);
	var version = findSingletonVersionKey(scope, key, eager);
	if (!satisfy(requiredVersion, version)) {
		fail(getInvalidSingletonVersionMessage(scope, key, version, requiredVersion));
	}
	return get(scope[key][version]);
});
var installedModules = {};
var moduleToHandlerMapping = {
	15237: () => (loadStrictVersion("default", "universal-cookie", false, [1,8,0,1], () => (__webpack_require__.e(4750).then(() => (() => (__webpack_require__(34750))))))),
	17745: () => (loadSingletonVersion("default", "mobx", false, [1,6,6,0], () => (__webpack_require__.e(4812).then(() => (() => (__webpack_require__(64812))))))),
	57538: () => (loadSingletonVersion("default", "mobx-react", false, [1,7,5,0], () => (__webpack_require__.e(6233).then(() => (() => (__webpack_require__(96233))))))),
	64628: () => (loadStrictVersion("default", "react-router-dom", false, [1,5,2,0], () => (__webpack_require__.e(201).then(() => (() => (__webpack_require__(62582))))))),
	82797: () => (loadStrictVersion("default", "react-router", false, [1,5,2,0], () => (__webpack_require__.e(1688).then(() => (() => (__webpack_require__(91688))))))),
	89205: () => (loadSingletonVersion("default", "react-dom", false, [4,18,3,1], () => (__webpack_require__.e(7950).then(() => (() => (__webpack_require__(97950))))))),
	96336: () => (loadStrictVersion("default", "query-string", false, [1,7,1,1], () => (__webpack_require__.e(9370).then(() => (() => (__webpack_require__(9370))))))),
	98283: () => (loadSingletonVersion("default", "react", false, [4,18,3,1], () => (__webpack_require__.e(5043).then(() => (() => (__webpack_require__(65043))))))),
	99314: () => (loadStrictVersion("default", "moment", false, [1,2,29,4], () => (__webpack_require__.e(6178).then(() => (() => (__webpack_require__(86178))))))),
	93305: () => (loadStrictVersion("default", "@nivo/core", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(1778), __webpack_require__.e(1645), __webpack_require__.e(1271), __webpack_require__.e(8598), __webpack_require__.e(5652)]).then(() => (() => (__webpack_require__(25652))))))),
	6489: () => (loadStrictVersion("default", "chart.js", false, [1,2,9,4], () => (Promise.all([__webpack_require__.e(6518), __webpack_require__.e(9314)]).then(() => (() => (__webpack_require__(76518))))))),
	64677: () => (loadStrictVersion("default", "date-fns", false, [1,3,6,0], () => (__webpack_require__.e(4194).then(() => (() => (__webpack_require__(64194))))))),
	96050: () => (loadStrictVersion("default", "d3", false, [1,7,6,1], () => (Promise.all([__webpack_require__.e(7979), __webpack_require__.e(1645), __webpack_require__.e(1271), __webpack_require__.e(6824), __webpack_require__.e(8598), __webpack_require__.e(8042)]).then(() => (() => (__webpack_require__(68042))))))),
	2811: () => (loadStrictVersion("default", "@nivo/bar", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(1778), __webpack_require__.e(6560), __webpack_require__.e(1645), __webpack_require__.e(2099), __webpack_require__.e(1271), __webpack_require__.e(5417), __webpack_require__.e(1149), __webpack_require__.e(1903), __webpack_require__.e(4224), __webpack_require__.e(3305)]).then(() => (() => (__webpack_require__(34224))))))),
	11658: () => (loadStrictVersion("default", "html-to-image", false, [4,1,11,11], () => (__webpack_require__.e(5316).then(() => (() => (__webpack_require__(55316))))))),
	19337: () => (loadStrictVersion("default", "react-apexcharts", false, [4,1,3,9], () => (__webpack_require__.e(2019).then(() => (() => (__webpack_require__(22019))))))),
	24262: () => (loadStrictVersion("default", "@nivo/pie", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(6560), __webpack_require__.e(2099), __webpack_require__.e(9564), __webpack_require__.e(1655), __webpack_require__.e(5686)]).then(() => (() => (__webpack_require__(61655))))))),
	29164: () => (loadStrictVersion("default", "react-bootstrap", false, [2,0,32,1], () => (__webpack_require__.e(8296).then(() => (() => (__webpack_require__(48296))))))),
	34299: () => (loadStrictVersion("default", "react-chartjs-2", false, [1,2,11,1], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(1778), __webpack_require__.e(139), __webpack_require__.e(1251)]).then(() => (() => (__webpack_require__(70139))))))),
	35337: () => (loadStrictVersion("default", "react-muuri", false, [2,0,3,0], () => (__webpack_require__.e(4749).then(() => (() => (__webpack_require__(74749))))))),
	51065: () => (loadStrictVersion("default", "react-csv", false, [1,2,2,2], () => (__webpack_require__.e(2378).then(() => (() => (__webpack_require__(62378))))))),
	56484: () => (loadStrictVersion("default", "react-gauge-component", false, [1,1,2,21], () => (Promise.all([__webpack_require__.e(9804), __webpack_require__.e(6050)]).then(() => (() => (__webpack_require__(59804))))))),
	57578: () => (loadStrictVersion("default", "chartjs-plugin-datalabels", false, [2,0,7,0], () => (Promise.all([__webpack_require__.e(9707), __webpack_require__.e(8870)]).then(() => (() => (__webpack_require__(69707))))))),
	58103: () => (loadStrictVersion("default", "chartjs-chart-geo", false, [1,2,1,0], () => (Promise.all([__webpack_require__.e(6243), __webpack_require__.e(6489)]).then(() => (() => (__webpack_require__(66243))))))),
	63303: () => (loadStrictVersion("default", "react-tooltip", false, [1,5,18,1], () => (Promise.all([__webpack_require__.e(5885), __webpack_require__.e(7943)]).then(() => (() => (__webpack_require__(57943))))))),
	70552: () => (loadStrictVersion("default", "@nivo/line", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(1778), __webpack_require__.e(6560), __webpack_require__.e(1645), __webpack_require__.e(2099), __webpack_require__.e(1271), __webpack_require__.e(5417), __webpack_require__.e(1903), __webpack_require__.e(6824), __webpack_require__.e(2368), __webpack_require__.e(8067)]).then(() => (() => (__webpack_require__(42368))))))),
	70855: () => (loadStrictVersion("default", "@nivo/sankey", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(6560), __webpack_require__.e(2099), __webpack_require__.e(8475), __webpack_require__.e(3781)]).then(() => (() => (__webpack_require__(98475))))))),
	73063: () => (loadStrictVersion("default", "@nivo/scatterplot", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(1778), __webpack_require__.e(6560), __webpack_require__.e(1645), __webpack_require__.e(2099), __webpack_require__.e(1271), __webpack_require__.e(5417), __webpack_require__.e(1149), __webpack_require__.e(1903), __webpack_require__.e(6824), __webpack_require__.e(5865), __webpack_require__.e(8543)]).then(() => (() => (__webpack_require__(95865))))))),
	80276: () => (loadStrictVersion("default", "jspdf", false, [1,4,2,1], () => (__webpack_require__.e(6396).then(() => (() => (__webpack_require__(6396))))))),
	86533: () => (loadStrictVersion("default", "@nivo/radial-bar", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(1778), __webpack_require__.e(6560), __webpack_require__.e(1645), __webpack_require__.e(2099), __webpack_require__.e(1271), __webpack_require__.e(5417), __webpack_require__.e(9564), __webpack_require__.e(229), __webpack_require__.e(6162)]).then(() => (() => (__webpack_require__(70229))))))),
	87374: () => (loadStrictVersion("default", "react-d3-speedometer", false, [1,3,1,1], () => (__webpack_require__.e(9139).then(() => (() => (__webpack_require__(9139))))))),
	90942: () => (loadStrictVersion("default", "@nivo/funnel", false, [2,0,99,0], () => (Promise.all([__webpack_require__.e(7224), __webpack_require__.e(7979), __webpack_require__.e(116), __webpack_require__.e(1778), __webpack_require__.e(6560), __webpack_require__.e(1645), __webpack_require__.e(1149), __webpack_require__.e(4751), __webpack_require__.e(448)]).then(() => (() => (__webpack_require__(66827))))))),
	45286: () => (loadStrictVersion("default", "react-select", false, [4,5,8,3], () => (Promise.all([__webpack_require__.e(5885), __webpack_require__.e(436), __webpack_require__.e(2364)]).then(() => (() => (__webpack_require__(2364))))))),
	70298: () => (loadStrictVersion("default", "react-table", false, [1,7,8,0], () => (__webpack_require__.e(1094).then(() => (() => (__webpack_require__(71094))))))),
	6410: () => (loadStrictVersion("default", "react-datepicker", false, [1,6,4,0], () => (Promise.all([__webpack_require__.e(1899), __webpack_require__.e(4677)]).then(() => (() => (__webpack_require__(31899))))))),
	14319: () => (loadStrictVersion("default", "react-grid-layout", false, [1,1,3,4], () => (__webpack_require__.e(399).then(() => (() => (__webpack_require__(399))))))),
	32325: () => (loadStrictVersion("default", "react-beautiful-dnd", false, [1,13,1,1], () => (__webpack_require__.e(5419).then(() => (() => (__webpack_require__(25419))))))),
	91919: () => (loadStrictVersion("default", "uuid", false, [1,11,1,1], () => (__webpack_require__.e(1056).then(() => (() => (__webpack_require__(31056))))))),
	32699: () => (loadStrictVersion("default", "web-vitals", false, [1,2,1,4], () => (__webpack_require__.e(6453).then(() => (() => (__webpack_require__(46453))))))),
	13725: () => (loadStrictVersion("default", "dompurify", false, [1,3,4,11], () => (__webpack_require__.e(7977).then(() => (() => (__webpack_require__(87977)))))))
};
// no consumes in initial chunks
var chunkMapping = {
	"23": [
		89205,
		98283
	],
	"187": [
		89205,
		93305,
		98283
	],
	"443": [
		89205,
		98283
	],
	"448": [
		93305
	],
	"579": [
		98283
	],
	"664": [
		98283
	],
	"838": [
		96050,
		98283
	],
	"1140": [
		98283
	],
	"1251": [
		6489
	],
	"1644": [
		89205,
		93305,
		98283
	],
	"1868": [
		2811,
		14319,
		19337,
		24262,
		29164,
		32325,
		34299,
		51065,
		57578,
		58103,
		63303,
		70552,
		70855,
		73063,
		86533,
		87374,
		90942,
		91919
	],
	"2404": [
		89205,
		98283
	],
	"2568": [
		89205,
		93305,
		98283
	],
	"2582": [
		82797,
		98283
	],
	"2699": [
		32699
	],
	"2858": [
		15237,
		17745,
		57538,
		64628,
		82797,
		89205,
		96336,
		98283,
		99314
	],
	"3305": [
		93305
	],
	"3521": [
		98283
	],
	"3725": [
		13725
	],
	"3754": [
		2811,
		11658,
		19337,
		24262,
		29164,
		34299,
		35337,
		51065,
		56484,
		57578,
		58103,
		63303,
		70552,
		70855,
		73063,
		80276,
		86533,
		87374,
		90942
	],
	"3781": [
		93305
	],
	"4025": [
		89205,
		93305,
		98283
	],
	"4501": [
		89205,
		93305,
		98283
	],
	"4508": [
		6410,
		45286,
		63303
	],
	"4677": [
		64677
	],
	"4679": [
		2811,
		11658,
		19337,
		24262,
		29164,
		34299,
		51065,
		57578,
		58103,
		63303,
		70552,
		70855,
		73063,
		80276,
		86533,
		87374,
		90942
	],
	"5468": [
		29164,
		45286,
		63303,
		70298
	],
	"5656": [
		89205,
		93305,
		98283
	],
	"5686": [
		93305
	],
	"5902": [
		98283
	],
	"6050": [
		96050
	],
	"6162": [
		93305
	],
	"6489": [
		6489
	],
	"6882": [
		89205,
		93305,
		98283
	],
	"7375": [
		2811,
		11658,
		19337,
		24262,
		29164,
		34299,
		35337,
		51065,
		56484,
		57578,
		58103,
		63303,
		70552,
		70855,
		73063,
		80276,
		86533,
		87374,
		90942
	],
	"8067": [
		93305
	],
	"8283": [
		98283
	],
	"8543": [
		93305
	],
	"8707": [
		6489,
		98283
	],
	"8759": [
		98283
	],
	"8870": [
		6489
	],
	"9263": [
		89205,
		93305,
		98283
	],
	"9314": [
		99314
	],
	"9703": [
		17745,
		89205,
		98283
	],
	"9931": [
		64677,
		89205,
		98283
	],
	"9983": [
		89205,
		98283
	],
	"9997": [
		98283
	]
};
var startedInstallModules = {};
__webpack_require__.f.consumes = (chunkId, promises) => {
	if(__webpack_require__.o(chunkMapping, chunkId)) {
		chunkMapping[chunkId].forEach((id) => {
			if(__webpack_require__.o(installedModules, id)) return promises.push(installedModules[id]);
			if(!startedInstallModules[id]) {
			var onFactory = (factory) => {
				installedModules[id] = 0;
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					module.exports = factory();
				}
			};
			startedInstallModules[id] = true;
			var onError = (error) => {
				delete installedModules[id];
				__webpack_require__.m[id] = (module) => {
					delete __webpack_require__.c[id];
					throw error;
				}
			};
			try {
				var promise = moduleToHandlerMapping[id]();
				if(promise.then) {
					promises.push(installedModules[id] = promise.then(onFactory)['catch'](onError));
				} else onFactory(promise);
			} catch(e) { onError(e); }
			}
		});
	}
}